export enum CertificateFeature {
  // Features that control access to wizard flow
  UNDER_18_ALLOWED = 'UNDER_18_ALLOWED',
  FOREIGN_MUNICIPALITY_ALLOWED = 'FOREIGN_MUNICIPALITY_ALLOWED',
  UNKNOWN_OR_NO_MUNICIPALITY_ALLOWED = 'UNKNOWN_OR_NO_MUNICIPALITY_ALLOWED',
  EIDAS_ALLOWED = 'EIDAS_ALLOWED',
  ALAND_ALLOWED = 'ALAND_ALLOWED',
  MARRIED_DISALLOWED = 'MARRIED_DISALLOWED',
  REGISTERED_PARTNERSHIP_DISALLOWED = 'REGISTERED_PARTNERSHIP_DISALLOWED',
  // Features that control availability of selections on wizard flow
  ORDER_FOR_DEPENDANTS = 'ORDER_FOR_DEPENDANTS',
  INCLUDE_PREVIOUS_MARRIAGES = 'INCLUDE_PREVIOUS_MARRIAGES',
  INCLUDE_PREVIOUS_NAMES = 'INCLUDE_PREVIOUS_NAMES',
  INCLUDE_PREVIOUS_PERMANENT_ADDRESSES = 'INCLUDE_PREVIOUS_PERMANENT_ADDRESSES',
  INCLUDE_HETU = 'INCLUDE_HETU',
  INCLUDE_MARITAL_STATUS = 'INCLUDE_MARITAL_STATUS',
  INCLUDE_TRANSLATION = 'INCLUDE_TRANSLATION',
  INCLUDE_APOSTILLE = 'INCLUDE_APOSTILLE',
  INCLUDE_SPOUSE_PREVIOUS_NAMES = 'INCLUDE_SPOUSE_PREVIOUS_NAMES',
  INCLUDE_NATIONALITY = 'INCLUDE_NATIONALITY',
  INCLUDE_PERMANENT_ADDRESS = 'INCLUDE_PERMANENT_ADDRESS',
  INCLUDE_PREVIOUS_TEMPORARY_ADDRESSES = 'INCLUDE_PREVIOUS_TEMPORARY_ADDRESSES',
  INCLUDE_PREVIOUS_KOTIKUNTA = 'INCLUDE_PREVIOUS_KOTIKUNTA',
  INCLUDE_KOTIKUNTA = 'INCLUDE_KOTIKUNTA',
  INCLUDE_PARENTS_HETU = 'INCLUDE_PARENTS_HETU',
  INCLUDE_PARENTS_PREVIOUS_NAMES = 'INCLUDE_PARENTS_PREVIOUS_NAMES',
  INCLUDE_NUMBER_OF_MARRIAGES = 'INCLUDE_NUMBER_OF_MARRIAGES',
}
